import './PaymentFinePrint.css';
import React from 'react';
import {
  ChangePlanPaymentFinePrint,
  ChangeSheerPlanPaymentFinePrint,
  DowngradePlanPaymentFinePrint,
  PaymentPlanFinePrint,
  UpgradePlanPaymentFinePrint,
} from 'Components/FinePrint';
import { isDowngradeSubscription } from 'Utils/Subscriptions';
import { SHEER_FIRST_RESPONDER_TYPE, SHEER_MILITARY_TYPE } from 'Utils/Constants';

export const PaymentFinePrint = ({
  purchaseMode = {},
  ctaText,
  sheerIdProgram,
  isVaUser,
  subscription,
  selectedPlan,
}) => {
  let changePlanFineprint = <></>;

  if (purchaseMode.isChangePlan) {
    if (sheerIdProgram === SHEER_MILITARY_TYPE || isVaUser || sheerIdProgram === SHEER_FIRST_RESPONDER_TYPE) {
      changePlanFineprint = <ChangeSheerPlanPaymentFinePrint />;
    } else if (isDowngradeSubscription(subscription, selectedPlan)) {
      changePlanFineprint = <DowngradePlanPaymentFinePrint ctaText={ctaText} />;
    } else {
      changePlanFineprint = <UpgradePlanPaymentFinePrint ctaText={ctaText} />;
    }
  }

  return (
    <div className="paymentFinePrintWrapper">
      {purchaseMode.isChangePlan ? (
        changePlanFineprint
      ) : (
        <PaymentPlanFinePrint ctaText={ctaText} sheerIdProgram={sheerIdProgram} isVaUser={isVaUser} />
      )}
    </div>
  );
};
